module.exports = __webpack_public_path__ + "img/awazuhara-san.9600ef21.jpg";